// extracted by mini-css-extract-plugin
module.exports = {"controlButton":"_1O7Jh","hidden":"_3lMcB","timeWrapper":"_3Kqa4","time":"DIWz5","duration":"lHicC","liveMode":"KKSZ3","separator":"_3Fu-a"};